import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="relative rounded-xl md:rounded-2xl overflow-hidden mb-10 md:mb-14 mx-4 md:mx-0">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20collage%20with%20multiple%20character%20silhouettes%2C%20warm%20golden%20and%20soft%20pink%20gradient%20background%2C%20dreamy%20ethereal%20atmosphere%2C%20film%20grain%20texture%2C%20cinematic%20lighting%2C%20artistic%20composition&width=1200&height=500&seq=cta-anime-collage&orientation=landscape"
              alt="樱花动漫社区"
              className="w-full aspect-[21/9] object-cover"
              loading="lazy"
            />
          </div>

          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight">
            加入<span className="italic font-heading text-primary-500">樱花动漫</span>
            <br />
            开启你的<span className="text-foreground-900">二次元之旅</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-lg mx-auto leading-relaxed">
            每日更新最新番剧，深度分析热门作品，和千万动漫迷一起分享你的热爱
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hot-blooded"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              开始探索
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-foreground-900 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}